import { useState } from 'react';
import useReveal from '../hooks/useReveal';
import { PRODUCTS } from '../data/data';

const CATEGORIES = ['All','Rice','Cooking Oil','Dal & Pulses','Spices','Flour','Beverages'];

export default function ProductsPage({ setPage }) {
  const [activeFilter, setActiveFilter] = useState('All');
  useReveal();
  const go = (id) => { setPage(id); window.scrollTo(0, 0); };
  const filtered = activeFilter==='All' ? PRODUCTS : PRODUCTS.filter(p=>p.category===activeFilter);

  return (
    <div>
      {/* Hero */}
      <div className="page-hero">
        <div className="page-hero-inner">
          <div className="breadcrumb"><span>Home</span><span className="sep">/</span><span className="active">Products</span></div>
          <h1>Our Product Range</h1>
          <p style={{ color:'rgba(255,255,255,.75)', fontSize:'1.05rem', lineHeight:1.8, maxWidth:620 }}>
            200+ quality-checked wholesale products — rice, oils, dal, spices, flour and daily essentials — delivered directly to your kirana shop or restaurant.
          </p>
        </div>
      </div>

      {/* Sticky filter bar */}
      <div style={{ background:'#fff', borderBottom:'1px solid var(--border)', padding:'18px 5vw', position:'sticky', top:72, zIndex:100, boxShadow:'0 2px 12px rgba(0,0,0,.04)' }}>
        <div className="container" style={{ display:'flex', gap:10, flexWrap:'wrap', alignItems:'center' }}>
          <span style={{ fontSize:'.75rem', fontWeight:700, color:'var(--text-light)', textTransform:'uppercase', letterSpacing:'.08em', marginRight:4 }}>Filter:</span>
          {CATEGORIES.map(cat=>(
            <button key={cat} onClick={()=>setActiveFilter(cat)} style={{ padding:'7px 18px', borderRadius:4, border:`1.5px solid ${activeFilter===cat?'var(--orange)':'var(--border)'}`, background:activeFilter===cat?'var(--orange)':'transparent', color:activeFilter===cat?'#fff':'var(--text-mid)', fontFamily:"'DM Sans',sans-serif", fontWeight:600, fontSize:'.84rem', cursor:'pointer', transition:'all .2s', whiteSpace:'nowrap' }}>
              {cat}
            </button>
          ))}
          <span style={{ marginLeft:'auto', fontSize:'.82rem', color:'var(--text-light)' }}>{filtered.length} products</span>
        </div>
      </div>

      {/* Product Grid with real photos */}
      <section style={{ padding:'60px 5vw 96px', background:'var(--cream)' }}>
        <div className="container">
          <div style={{ display:'grid', gap:24 }} className="full-prod-grid">
            {filtered.map((p,i)=>(
              <div key={p.id} className="product-card reveal" style={{ animationDelay:`${(i%6)*.07}s` }}>
                <div style={{ height:220, overflow:'hidden', position:'relative' }}>
                  <img src={p.photo} alt={p.name} style={{ width:'100%', height:'100%', objectFit:'cover', transition:'transform .4s' }}
                    onMouseEnter={e=>e.target.style.transform='scale(1.06)'}
                    onMouseLeave={e=>e.target.style.transform='scale(1)'}
                  />
                  <div style={{ position:'absolute', inset:0, background:'linear-gradient(to top, rgba(26,15,5,.35) 0%, transparent 60%)' }} />
                  <span style={{ position:'absolute', top:14, right:14, background:'rgba(255,255,255,.92)', borderRadius:4, padding:'3px 10px', fontSize:'.68rem', fontWeight:700, color:p.accent, letterSpacing:'.05em', textTransform:'uppercase' }}>{p.category}</span>
                </div>
                <div style={{ padding:'22px 24px 28px' }}>
                  <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:'1.15rem', fontWeight:700, color:'var(--dark)', marginBottom:10 }}>{p.name}</h3>
                  <p style={{ fontSize:'.87rem', color:'var(--text-mid)', lineHeight:1.82, marginBottom:16 }}>{p.desc}</p>
                  <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginBottom:14 }}>
                    {p.highlights.map((h,j)=>(<span key={j} style={{ fontSize:'.7rem', background:'var(--orange-pale)', color:'var(--orange)', padding:'3px 10px', borderRadius:20, fontWeight:600 }}>{h}</span>))}
                  </div>
                  <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginBottom:18 }}>
                    {p.sizes.map((s,j)=>(<span key={j} style={{ fontSize:'.7rem', background:'var(--cream-dark)', color:'var(--text-mid)', padding:'3px 10px', borderRadius:20, fontWeight:600 }}>📦 {s}</span>))}
                  </div>
                  <div style={{ borderTop:'1px solid var(--border)', paddingTop:16, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                    <span style={{ fontSize:'.77rem', color:'var(--orange)', fontWeight:600 }}>✅ Quality Checked</span>
                    <button onClick={()=>go('contact')} style={{ background:'none', border:'none', cursor:'pointer', fontSize:'.82rem', fontWeight:700, color:'var(--orange)', fontFamily:"'DM Sans',sans-serif" }}>Get Quote →</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <style>{`.full-prod-grid{grid-template-columns:repeat(3,1fr)!important;} @media(max-width:900px){.full-prod-grid{grid-template-columns:repeat(2,1fr)!important;}} @media(max-width:540px){.full-prod-grid{grid-template-columns:1fr!important;}}`}</style>
        </div>
      </section>

      {/* B2B CTA */}
      <section style={{ padding:'64px 5vw', background:'var(--orange-pale)', borderTop:'1px solid var(--border)' }}>
        <div className="container">
          <div style={{ display:'flex', alignItems:'center', gap:48, flexWrap:'wrap' }}>
            <div style={{ flex:1, minWidth:260 }} className="reveal">
              <div className="tag-line">B2B Wholesale Only</div>
              <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:'1.6rem', fontWeight:700, color:'var(--dark)', marginBottom:12 }}>Don't See What You Need?</h3>
              <p style={{ fontSize:'.95rem', color:'var(--text-mid)', lineHeight:1.85 }}>Our full catalogue has 200+ products. WhatsApp or call us — we can likely source it for you at wholesale rates.</p>
            </div>
            <div style={{ display:'flex', gap:14, flexWrap:'wrap' }} className="reveal">
              <a href="https://wa.me/919121927878" target="_blank" rel="noopener noreferrer" className="btn-primary">📋 Request Full Price List</a>
              <a href="tel:+919121927878" className="btn-outline">📞 Call Us Now</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
